//
//
//
//
import List from "./../../components/product/list/List.vue";
export default {
  name: "ListForEdit",
  components: {
    List: List
  }
};